'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdExposureZero = function MdExposureZero(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 16.9c0-2-0.2-3.4-0.9-4.5-0.3-0.4-0.7-0.7-1.1-0.9s-0.9-0.3-1.4-0.3-1 0-1.4 0.3-0.8 0.5-1.1 0.9c-0.7 1.1-0.9 2.5-0.9 4.5v4.4c0 2.7 0.4 4.6 2 5.6 0.4 0.2 0.9 0.3 1.4 0.3 1.3 0 1.9-0.5 2.5-1.3 0.7-1.1 0.9-2.7 0.9-4.6v-4.4h0z m-10.3 0.5c0-5.3 1.7-9 6.9-9 3.6 0 5.6 1.8 6.4 4.8 0.3 1.2 0.6 2.5 0.6 4.2v3.5h-0.1c0 3.1-0.6 5.4-1.9 7-0.6 0.7-1.3 1.3-2.2 1.6s-1.8 0.5-2.8 0.5-2-0.2-2.8-0.5-1.6-0.9-2.2-1.6c-1.4-1.5-1.9-4-1.9-7v-3.5z' })
        )
    );
};

exports.default = MdExposureZero;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/exposure-zero.js
// module id = 1425
// module chunks = 168707334958949